// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-pages-authSuccess-__index__wrap--1T_eJ","tip":"src-pages-authSuccess-__index__tip--2YRu5"};